import { useColorScheme, useTheme } from "@mui/material/styles";
import { QRCodeSVG } from "qrcode.react";

function QRCode(props) {
  const theme = useTheme();
  const { colorScheme } = useColorScheme();

  return (
    <QRCodeSVG
      fgColor={theme.vars.palette.primary[500]}
      bgColor={colorScheme === "light" ? "#fff" : "#fff"}
      marginSize={colorScheme === "light" ? 0 : 1}
      id="qrcode"
      {...props}
    />
  );
}

export default QRCode;
